import { Component, EventEmitter, Input, OnInit, Output, ViewEncapsulation } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { ButtonTriggerEvent } from '../../../../common/components';
import { BaseComponent } from '../../../../common/components/base.component';
import { ModalService } from '../../../../common/services/modal.service';
import { EditorChoiceDataSource, HubEvent } from '../../../../models/hub/hub.event';
import { HubPlace } from '../../../../models/hub/hub.place';
import { ImageService } from '../../../../services/image.service';
import { EventDetailsModalComponent } from '../../event.details.modal/event.details.modal.component';
import { EventDetailsModalActions } from '../../event.details.modal/event.details.modal.provider';
import { PlaceDetailsModalComponent } from '../../place.details.modal/place.details.modal.component';
import { PlaceDetailsModalActions } from '../../place.details.modal/place.details.modal.provider';
import { TripDetailModalActions, TripDetailModalData } from '../../trip/trip.detail.modal/trip.detail.modal.provider';
import { TripDetailModalComponent } from '../../trip/trip.detail.modal/trip.detail.modal.component';
import { formatToDate, weekday } from '../../../../utils/common';
import { EditorChoiceStore } from '../../../../stores/hub.calendar.store';

@Component({
  selector: 'ig-visitor-modern-block',
  templateUrl: './visitor.modern.block.card.component.html',
  styleUrls: ['./visitor.modern.block.card.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class VisitorModernBlockCardComponent extends BaseComponent implements OnInit {
  @Input() public item: HubEvent | HubPlace;
  @Input() public isSimple = false;
  public eventTimeText = {
    week_day: '',  // deprecated
    date: [],   // deprecated
    eventDate: '',
    time: ''
  };
  public placeCategory = '';
  public editorChoiceText = '';
  public hubName: string;
  @Output() onclick: EventEmitter<any> = new EventEmitter();

  constructor(private router: Router,
              public imageService: ImageService,
              public modalService: ModalService,
              public editorChoiceStore: EditorChoiceStore,
              private activatedRoute: ActivatedRoute) {
    super({activatedRoute});
  }

  ngOnInit() {
    let {hubName} = this.allRouteParams;
    this.hubName = hubName;
    if (this.item.startTime) {
      // multiple dates event will just show "Multiple Dates Event" in the time section
      if (this.item.eventTimes.length === 1 && this.item.eventTimes[0].start) {
        const time = this.item.eventTimes[0];
        this.eventTimeText.eventDate = time.noTimeFormatted;
        this.eventTimeText.time = `${time.weekDay.substr(0, 3)}.${time.start.substring(0, time.start.lastIndexOf(' '))}`;
        if (time.end) {
          this.eventTimeText.time += ` - ${time.endWeekDay !== time.weekDay ? time.endWeekDay.substr(0, 3) + '.' : ''}${time.end.substring(0, time.end.lastIndexOf(' '))}`;
        }
      }
      // this.eventTimeText.week_day = weekday(new Date(this.item.startTime).getDay() - 0);
      // this.eventTimeText.date = formatToDate(this.item.startTimeText);
    } else {
      if (this.item['categoryList']) {
        this.placeCategory = '';
        let cate = '';
        for (let category of this.item['categoryList']) {
          cate += category + ', ';
          if (cate.length < 44) {
            this.placeCategory = cate;
          }
        }
        this.placeCategory = this.placeCategory.substr(0, this.placeCategory.length - 2);
      }
    }
    this.editorChoiceTextHandler();
  }

  public editorChoiceTextHandler() {
    this.editorChoiceStore.infoCommand.takeUntil(this.isDestroyed).subscribe((editorChoice: EditorChoiceDataSource) => {
      if (!!this.item.startTime) {
        this.editorChoiceText = editorChoice.editorChoiceForEvent;
      } else {
        this.editorChoiceText = editorChoice.editorChoiceForPlace;
      }
    });
  }

  public enterItemByKeyboard($event) {
    if ($event && $event.key === 'Enter') {
      this.showDetails();
    }
  }

  public showDetails() {
    if (this.item.isPromotionImage) {
      this.item.promotionLink = this.item.promotionLink.startsWith('http') ? this.item.promotionLink : 'http://' + this.item.promotionLink;
      window.open(this.item.promotionLink, '_blank');
      return;
    }
    this.onclick.emit();
    if (this.item.startTime) {
      if (!this.isMobile) {
        this.item.hubName = this.hubName;
        let actions = <EventDetailsModalActions>{
          confirm: (event: ButtonTriggerEvent, data: any) => {
          }
        };

        this.modalService.show({
          component: EventDetailsModalComponent,
          providers: [
            {provide: EventDetailsModalActions, useValue: actions},
            {provide: HubEvent, useValue: this.item},
          ],
          panelClass: 'modal-fixed-top-lower'
        });
      } else {
        this.showDetailModalForMobile(this.item, 'event');
      }
    } else {
      if (!this.isMobile) {

        let actions = <PlaceDetailsModalActions>{
          confirm: (event: ButtonTriggerEvent, data: any) => {
          }
        };

        this.modalService.show({
          component: PlaceDetailsModalComponent,
          providers: [
            {provide: PlaceDetailsModalActions, useValue: actions},
            {provide: HubPlace, useValue: this.item},
          ],
          panelClass: 'modal-fixed-top'
        });
      } else {
        this.showDetailModalForMobile(this.item, 'place');
      }
    }
  }

  public showDetailModalForMobile(item: any, displayingOn: string, isShowAddToTripBtn = false, index?: number) {
    let actions = <TripDetailModalActions>{
      confirm: (event: ButtonTriggerEvent) => {
      }
    };
    this.modalService.show({
      component: TripDetailModalComponent,
      providers: [
        {provide: TripDetailModalActions, useValue: actions},
        {
          provide: TripDetailModalData,
          useValue: new TripDetailModalData(item, displayingOn, this.hubName,
            null, null, isShowAddToTripBtn, index)
        }
      ],
      panelClass: ['width-modal-100p', 'ig-trip-info-modal'],
    });
  }
}


// WEBPACK FOOTER //
// D:/Work/Development/ImGoing/IMGoing/web/src/components/visitor/calendar/modern.block.card/visitor.modern.block.card.component.ts